import { graphql, HttpResponse } from 'msw'
import { type EnrollmentHYCSGetStartedData, type EnrollmentHYCSGetStartedSubmitOutput } from '../../../../models'

export const getEnrollmentHYCSGetStartedDataMock: EnrollmentHYCSGetStartedData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/get-started',
}

export const submitEnrollmentHYCSGetStartedDataMock: EnrollmentHYCSGetStartedSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/enter-phone',
}

export const mockGetEnrollmentHYCSGetStartedData = graphql.mutation('getEnrollmentHYCSGetStartedData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentHYCSGetStartedDataMock } })
})

export const mockSubmitEnrollmentHYCSGetStartedData = graphql.mutation('submitEnrollmentHYCSGetStartedData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentHYCSGetStartedDataMock } })
})

export const mockEnrollmentHYCSGetStarted = [
  mockGetEnrollmentHYCSGetStartedData,
  mockSubmitEnrollmentHYCSGetStartedData,
]
